import React from 'react';
import { observer } from 'mobx-react-lite';
import { TranslationKeys } from '../../../enums';
import { AboutHash, CheckHashPopupTopPart, HelpPopUp } from '../../../components';
import betImg1 from '../../../assets/images/bet-item-img1.png';
import betImg3 from '../../../assets/images/bet-item-img3.png';
import betImg4 from '../../../assets/images/bet-item-img4.png';
import betImg2 from '../../../assets/images/bet-item-img2.png';
import { rtpData } from '../../../enums/rtpData';
import betImgBonus from '../../../assets/images/bet-bonus-img.png';
import { candyDataStore } from '../../../store';

export const GameSpecificCheckHashPopupTopSection = ({ currentData }) => {
  return <CheckHashPopupTopPart roundData={currentData.roundData} currentData={currentData} />;
};

export const OddsContent = observer(({ t }) => {
  const { rtpType } = candyDataStore;

  return (
    <>
      <div className='dream-wheel-table'>
        <div className='dream-wheel-table-holder'>
          <div className='dream-wheel-table-row'>
            <div className='dream-wheel-table-column'>
              <p className='d-w-h-p'>{t(TranslationKeys.Symbol)}</p>
            </div>
            <div className='dream-wheel-table-column'>
              <p className='d-w-h-p'>{t(TranslationKeys.Odd)}</p>
            </div>
          </div>
          <div className='dream-wheel-table-row'>
            <div className='dream-wheel-table-column'>
              <img src={betImg1} className='pink-candy' alt='pink-candy' />
              <img src={betImg3} className='green-candy' alt='green-candy' />
              <img src={betImg4} className='blue-candy' alt='blue-candy' />
              <img src={betImg2} className='orange-candy' alt='orange-candy' />
            </div>
            <div className='dream-wheel-table-column'>
              <p className='dream-wheel-table-column-coef'>x{rtpData[rtpType]}</p>
            </div>
          </div>
          <div className='dream-wheel-table-row'>
            <div className='dream-wheel-table-column'>
              <img src={betImgBonus} className='prize-box' alt='betImgBonus' />
            </div>
            <div className='dream-wheel-table-column'>
              <p className='dream-wheel-table-column-coef'>{t(TranslationKeys.UpTo)} - x100</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export const AboutBonus = ({ t }) => {
  return (
    <>
      <p>{t(TranslationKeys.GameRulesP10)}</p>
      <p>{t(TranslationKeys.GameRulesP11)}</p>
      <p>{t(TranslationKeys.GameRulesP12)}</p>
      <p>{t(TranslationKeys.GameRulesP13)}</p>
      <p>{t(TranslationKeys.GameRulesP14)}</p>
      <p>{t(TranslationKeys.GameRulesP15)}</p>
    </>
  );
};

export const AboutHashInnerContent = ({ t }) => {
  return <AboutHash t={t} />;
};

export const HelpPopupContent = () => {
  return <HelpPopUp />;
};
